import script from "./MoleculeGoal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeGoal.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeGoal.vue?vue&type=style&index=0&id=4d2de57f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2de57f"]])

export default __exports__